import { apiClient } from './apiClient'

export interface BookCategory {
  id: string
  name: string
  nameEn: string
  description?: string
  order: number
}

export interface Book {
  id: string
  title: string
  author?: string
  description?: string
  categoryId?: string
  categoryName?: string
  coverImageUrl?: string
  pdfUrl?: string
  order: number
  parentBookId?: string
  topics?: Topic[]
}

export interface Topic {
  id: string
  bookId: string
  book?: { id: string; title: string }
  title: string
  content: string
  parentTopicId?: string
  parentTopic?: { id: string; title: string }
  childTopics?: Topic[]
  order: number
  evidences?: Evidence[]
  relatedTopics?: RelatedTopic[]
}

export interface Evidence {
  id: string
  type: string
  reference: string
  arabicText?: string
  translation?: string
  order: number
}

export interface RelatedTopic {
  id: string
  title: string
  bookId: string
  bookTitle?: string
}

class LibraryApiService {
  async getCategories(): Promise<BookCategory[]> {
    const response = await apiClient.get<BookCategory[]>('/Library/categories')
    return response.data
  }

  async getBooks(categoryId?: string, search?: string): Promise<Book[]> {
    const params = new URLSearchParams()
    if (categoryId) params.append('categoryId', categoryId)
    if (search) params.append('search', search)
    const url = `/Library/books${params.toString() ? '?' + params.toString() : ''}`
    const response = await apiClient.get<Book[]>(url)
    return response.data
  }

  async getBook(id: string, language?: string): Promise<Book> {
    const params = language ? `?lang=${encodeURIComponent(language.split('-')[0])}` : ''
    const response = await apiClient.get<Book>(`/Library/books/${id}${params}`)
    return response.data
  }

  async getTopic(id: string): Promise<Topic> {
    const response = await apiClient.get<Topic>(`/Library/topics/${id}`)
    return response.data
  }
}

export const libraryApi = new LibraryApiService()


